<template>
  <div class="data-list-container">
    <!-- {{alladminpermission}} -->
    <vs-card v-if="actionlist.length">
      <div class="flex justify-between items-center mb-6">
        <div class="inline-flex items-center">
          <div class="light_blue_icon_holder">
            <span class="material-icons-outlined">person_outline</span>
          </div>
          <h4 style="text-transform: capitalize" class="pl-2">
            {{ moduleName }} Role Management
          </h4>
        </div>
        <vs-button @click="saveButton">Back</vs-button>
      </div>
      <vs-divider />
      <div class="tab_router_link_holder">
        <router-link
          class="active"
          :to="{
            name: 'role-module-set-access',
            params: {
              moduleId: moduleId,
              name: moduleName,
            },
          }"
        >
          <span class="material-icons-outlined">event</span>
          <span class="pl-2">Roles & Access Permissions</span>
        </router-link>
        <router-link
          :to="{
            name: 'role-user-module-access',
            params: {
              moduleId: moduleId,
              name: moduleName,
            },
          }"
        >
          <span class="material-icons-outlined">person</span>
          <span class="pl-2">User Profile</span>
        </router-link>
      </div>
      <div class="flex m-2 mb-4">
        <h4>All Permission</h4>
        <vs-checkbox
          color="primary"
          v-model="alladminpermission"
          @change="allpermission('A')"
        />
      </div>
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="3"
          vs-sm="6"
          vs-xs="12"
          v-for="(list, listIndex) in actionlist"
          :key="list.role_action_id"
          class="p-2"
        >
          <vs-card class="h-full">
            <vs-list>
              <vs-list-header :title="list.module_name"></vs-list-header>
              <div class="each-permission">
                <vs-checkbox
                  color="primary"
                  v-model="list.eachAllPermissionCheck"
                  @change="
                    eachModulePermission(
                      list.module_name,
                      listIndex,
                      list.eachAllPermissionCheck
                    )
                  "
                />
              </div>

              <div
                style="max-height: 250px; overflow: auto"
                class="vertical_scrollbar"
              >
                <vs-list-item
                  v-for="listaction in list.action_list"
                  :key="listaction.role_action_id"
                  :title="listaction.entity_name"
                  class="flex justify-between items-center"
                >
                  <vs-checkbox
                    v-model="listaction.enabled"
                    color="primary"
                    style="margin-right: 0"
                    @change="
                      permission(
                        listaction.enabled,
                        listaction.role_action_id,
                        list.platform_module_id,
                        listIndex,
                        list
                      )
                    "
                  >
                  </vs-checkbox>
                </vs-list-item>
              </div>
            </vs-list>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-card>

    <!-- <vs-row vs-type="flex" vs-justify="flex-end">
      <vs-button color="primary" style="float: right" @click="saveButton"
        >Back</vs-button
      >
    </vs-row> -->
  </div>
</template>

<script>
import {
  Fetch_list_action,
  ModluePermission,
  AllModulePermission,
  FetchEditRole
} from '@/api/role'

export default {
  props: {
    module_id: null,
    module_name: null
  },
  data () {
    return {
      
      actionlist: [],
      educationactionlist: [],
      alladminpermission: '',
      alleducationpermission: '',
      moduleName:this.$route.params.name
        ? this.$route.params.name
        : this.module_name,
      moduleId: this.$route.params.moduleId
        ? this.$route.params.moduleId
        : this.module_id
    }
  },
  mounted () {
    this.moduleName = this.$route.params.name
      ? this.$route.params.name
      : this.module_name
    this.moduleId = this.$route.params.moduleId
      ? this.$route.params.moduleId
      : this.module_id
    this.fetch_action_list()
    this.fetch_roles()
  },
  methods: {
    saveButton () {
      console.log(this.module_id)
      const payload = {
        tabIndex: 2
      }
      this.$emit('saveSystem', payload)
      this.$router.push({ name: 'v1-settings', params: {tabIndex: 2}})
    },

    async fetch_roles () {
      try {

        console.log(this.moduleId)


        const data = await FetchEditRole(this.moduleId)
        this.alladminpermission =
          data.data.data.role_details.admin_portal_access_all_permission
        this.alleducationpermission =
          data.data.data.role_details.education_portal_access_all_permission
      } catch (e) {
        console.log(e)
      }
    },

    async fetch_action_list () {
      this.$vs.loading()

      try {
        const customerId = localStorage.getItem('customer_id')

        console.log(this.moduleId)

        const payload = {
          user_role_id: this.moduleId,
          portal_type: 'A',
          customer_id: customerId
        }

        const { data } = await Fetch_list_action(payload)

        this.actiondatalist = data.data.list
        this.actionlist = this.actiondatalist.filter((element) => {
          if (element.action_list.length > 0) {
            return element
          }
        })

        this.actionlist.forEach((ele) => {
          ele.eachAllPermissionCheck = this.checkingEachPermission(ele)
        })

        // this.fetch_education_list()

        this.$vs.loading.close()

        // this.custom_fields = data.data.custom_fields
        // this.entityModel = data.data.entitymodels
        //
      } catch (e) {
        this.$vs.loading.close()

        // this.$vs.loading.close()
      }
    },
    permission (enable, roleactionid, platformmoduleid, listIndex, listaction) {
      const customerId = localStorage.getItem('customer_id')

      const payload = {
        role_action_id: roleactionid,
        platform_module_id: platformmoduleid,
        user_role_id: this.moduleId,
        enabled: enable ? 1 : 0,
        customer_id: customerId
      }

      this.PermissionModuleSet(payload, listIndex, listaction)
    },
    async PermissionModuleSet (payload, listIndex, listaction = {}) {
      //
      //
      try {
        if (!Array.isArray(payload)) {
          this.$vs.loading()

          const { data } = await ModluePermission(payload)

          this.alladminpermission =
            data.data.roleDetails.admin_portal_access_all_permission
          this.alleducationpermission =
            data.data.roleDetails.education_portal_access_all_permission

          this.$vs.notify({
            title: 'Success',
            text: 'Platform Module Action Updated Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          const hasEachAllPermission = this.checkingEachPermission(listaction)

          // listaction.eachAllPermissionCheck = false
          // this.$set(listaction, 'eachAllPermissionCheck', false)

          //
          //
          this.$set(this.actionlist, listIndex, {
            ...this.actionlist[listIndex],
            eachAllPermissionCheck: hasEachAllPermission
          })

          // this.checkingEachPermission(listaction)
          this.$vs.loading.close()
        } else {
          const enabled = payload[0].enabled
          const promises = await payload.map((eachPayload) => ModluePermission(eachPayload)
          )
          const numFruits = await Promise.all(promises)
          if (numFruits.length) {
            this.actionlist[listIndex].action_list.forEach((ele) => {
              if (enabled === 1) {
                ele.enabled = true
              } else {
                ele.enabled = false
              }
            })
          }
          this.$vs.notify({
            title: 'Success',
            text: 'Permission Updated Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        }
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    allpermission (module) {
      let enabledp = ''
      if (module === 'A') {
        enabledp = this.alladminpermission
      } else {
        enabledp = this.alleducationpermission
      }
      const customerId = localStorage.getItem('customer_id')

      const payload = {
        user_role_id: this.moduleId,
        portal_type: module,
        enabled: enabledp ? 1 : 0,
        customer_id: customerId
      }
      this.allSetPermission(payload)
    },

    async allSetPermission (payload) {
      try {
        await AllModulePermission(payload)
        this.fetch_action_list()

        this.$vs.notify({
          title: 'Success',
          text: 'All Permission Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        console.log(e)
      }
    },
    eachModulePermission (moduleName, listIndex, checkbox) {
      const moduleActionArray = this.actionlist.filter((eachAction) => {
        return eachAction.module_name === moduleName
      })
      const platform_module_id = moduleActionArray[0].platform_module_id
      //
      // moduleActionArray[0].action_list.forEach(ele => {
      //   this.permission(1, ele.role_action_id, platform_module_id, 'eachModule')
      // })
      const customerId = localStorage.getItem('customer_id')

      const payloadArray = moduleActionArray[0].action_list.map(
        (eachAction) => {
          return {
            role_action_id: eachAction.role_action_id,
            platform_module_id,
            user_role_id: this.moduleId,
            enabled: checkbox ? 1 : 0,
            customer_id: customerId
          }
        }
      )

      this.PermissionModuleSet(payloadArray, listIndex)
    },
    checkingEachPermission (eachModule) {
      const length = eachModule.action_list.length
      const filteredArray = eachModule.action_list.filter((element) => {
        return element.enabled === 1 || element.enabled === true
      })
      if (length === filteredArray.length) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.vs-checkbox--input {
  height: 100px;
  width: 100px;
}
.each-permission {
  float: right;
  margin-top: -30px;
}
</style>
